import React, { Component } from 'react';
import { connect } from 'react-redux';

class Footer extends Component {
  static propTypes = {};
  render() {
    const { global } = this.props;
    return (
      <footer id="wrap-footer">
        <div className="container">
          <p className="text-muted text-center">
            <span className="hidden-xs"> 一級建築士試験 {global.appName}</span>{' '}
            v{window.config.version} &copy;
            {global.companyName}{' '}
          </p>
        </div>
      </footer>
    );
  }
}

function select({ global, userData, forms }) {
  return { global, userData, forms };
}
export default connect(select)(Footer);



// WEBPACK FOOTER //
// ./src/components/layout/Footer.js